import { useEffect, useState } from 'react';

export default function useLocationHash() {
    const [hash, setHash] = useState();

    useEffect(() => {
        // Skip this effect if we're not in the browser
        if (typeof window === 'undefined') {
            return;
        }

        const handleHashChange = () => {
            setHash(window.location.hash);
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    return hash;
}
